export { default } from './SearchResultsCard';
